































import Vue, { PropType } from 'vue'
import { GoodsSeries } from '@/types/generated/graphql'

export default Vue.extend({
  name: 'GoodsSeriesTab',
  data() {
    return {
      activeTab: 'all',
    }
  },
  props: {
    goodsSerieses: {
      type: Array as PropType<Array<GoodsSeries>>,
      required: true,
    },
  },
  methods: {
    filter(id: string) {
      this.$emit('filter', id)
    },
    reset() {
      this.$emit('reset')
    },
    changeTab(tabId: string) {
      this.activeTab = tabId
    },
    classes(goodsSeriesId: string) {
      return this.activeTab === goodsSeriesId ? 'active' : ''
    },
  },
})
